module.exports = __webpack_public_path__ + "static/media/Banner-stats.a5dbeb57.jpg";